import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEffect } from "react";

interface WeightScaleFlowProps {
  isOpen: boolean;
  onComplete: () => void;
}

const WeightScaleFlow = ({ isOpen, onComplete }: WeightScaleFlowProps) => {
  const navigate = useNavigate();

  // Handle Enter key for Continue button
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter" && isOpen && !e.shiftKey) {
        const target = e.target as HTMLElement;
        // Don't trigger if user is typing in input/textarea
        if (target.tagName !== "INPUT" && target.tagName !== "TEXTAREA") {
          e.preventDefault();
          onComplete();
        }
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
  }, [isOpen, onComplete]);

  if (!isOpen) return null;

  return (
    <div className="space-y-6 mt-6">
      <Card>
        <CardHeader>
          <CardTitle>Weight Scale Flow</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">Weight scale flow will be implemented here.</p>
            <div className="flex justify-end gap-3 pt-4">
              <Button variant="outline" onClick={() => navigate("/alerts")}>
                Cancel
              </Button>
              <Button onClick={onComplete} className="bg-orange-500 hover:bg-orange-600 text-white">
                Continue
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default WeightScaleFlow;

